import ToggleSwitch from "@/components/shared/ToggleSwitch";
import { ConfirmModal } from "@/components/shared/ConfirmModal";
import useAnomaliesAdmin from "./hooks/useAnomaliesAdmin";
import {
  headerRowStyle,
  headerCellStyle,
  bodyCellStyle,
  nameCellStyle,
  tableContainerStyle,
  zebraRowStyle,
} from "./tableStyles";

export default function AnomaliesSection() {
  const {
    anomalyProcesses,
    isLoading,
    saving,
    error,
    pendingToggle,
    handleToggleRequest,
    handleCancelToggle,
    handleConfirmToggle,
  } = useAnomaliesAdmin();

  return (
    <section>
      {error && (
        <div
          role="alert"
          style={{
            padding: "0.75rem 1rem",
            marginBottom: "1rem",
            borderRadius: "0.375rem",
            border: "1px solid #fecaca",
            backgroundColor: "#fef2f2",
            color: "#991b1b",
            fontSize: "0.875rem",
          }}
        >
          {error instanceof Error ? error.message : "Something went wrong"}
        </div>
      )}
      {isLoading ? (
        <div className="text-muted">Loading anomalies…</div>
      ) : anomalyProcesses.length === 0 ? (
        error ? null : (
          <div className="text-muted">No anomaly processes found.</div>
        )
      ) : (
        <div style={tableContainerStyle}>
          <table className="table mb-0" style={{ tableLayout: "auto" }}>
            <thead>
              <tr style={headerRowStyle}>
                <th scope="col" style={headerCellStyle()}>
                  Name
                </th>
                <th scope="col" style={headerCellStyle()}>
                  Description
                </th>
                <th scope="col" style={headerCellStyle()}>
                  Type
                </th>
                <th scope="col" style={headerCellStyle()}>
                  Active
                </th>
              </tr>
            </thead>
            <tbody>
              {anomalyProcesses.map((anomalyProcess, index) => (
                <tr key={anomalyProcess.Id} style={zebraRowStyle(index)}>
                  <td style={nameCellStyle}>{anomalyProcess.Name}</td>
                  <td style={bodyCellStyle}>{anomalyProcess.Description}</td>
                  <td style={bodyCellStyle}>{anomalyProcess.Type}</td>
                  <td style={bodyCellStyle}>
                    <ToggleSwitch
                      checked={anomalyProcess.Active}
                      onChange={() => handleToggleRequest(anomalyProcess)}
                      label={`Toggle ${anomalyProcess.Name}`}
                      disabled={saving}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {pendingToggle && (
        <ConfirmModal
          title={`${pendingToggle.Active ? "Deactivate" : "Activate"} "${pendingToggle.Name}"?`}
          message={
            <>
              This will {pendingToggle.Active ? "deactivate" : "activate"}{" "}
              the <strong>{pendingToggle.Name}</strong> anomaly process and
              will affect site-level functionality for all users.
            </>
          }
          confirmText={pendingToggle.Active ? "Deactivate" : "Activate"}
          cancelText="Cancel"
          onCancel={handleCancelToggle}
          onConfirm={handleConfirmToggle}
        />
      )}
    </section>
  );
}
